module.exports = __webpack_public_path__ + "static/ru-4-cc5331ca006560609d3ef002956fa477.png";